import { useState } from "react";
import KitchenIndentVarianceReportDetails from "./KitchenIndentVarianceReportDetails";
import FilterData from "../FilterData";

const KitchenIndentVarianceReport = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [params,setParams] = useState()
  const handleClick = (): void => {
      setOpen(true);
  };  
  const handleFilterChange = (): void => {
    setOpen(false);
  };  
  const handleParamsChange = (values:any): void => {
    setParams(values)
  }
  return (
    <div className="content-wrapper">
      <h1 className="flex align-items-center">
        Projected Kitchen Indent vs Requested Kitchen Indent Variance Report
      </h1>
      <FilterData handleClick={handleClick} handleFilterChange={handleFilterChange} handleParamsChange={handleParamsChange}/>
      {open && 
        <KitchenIndentVarianceReportDetails params={params}/>
      }      
    </div>    
  );
};

export default KitchenIndentVarianceReport;
